module.exports = __webpack_public_path__ + "img/oem7.7d9467cb.png";